import { AutoComplete } from "rsuite";
//import "./AutoComplete.css";

const SCAutoComplete = ({ data, value, setValue, ...props }) => {
  return (
    <AutoComplete
      data={data}
      value={value}
      onChange={setValue}
      {...props}
    ></AutoComplete>
  );
};

export default SCAutoComplete;
